@if (loading) {
  <mbs-loader />
} @else {
  @if (showHeader) {
    <header
      class="modal-header mbs-modal_header"
      [ngClass]="getHeaderSizeClass()">
      <div class="form-row">
        @if (titleIconClass) {
          <div class="col-auto">
            <span class="ico {{ titleIconClass }} mbs-modal_title-ico"></span>
          </div>
        }
        <div
          class="col"
          [class.overflow-hidden]="titleTextOverflow">
          <h5 class="modal-title mbs-modal_title">
            @if (titleTextOverflow) {
              <mbs-text-ellipsis
                [placement]="'top-left auto'"
                [tooltip]="title"
                [tooltipClass]="'tooltip-lg'">
                {{ title }}
              </mbs-text-ellipsis>
            } @else {
              {{ title }}
            }
            <ng-content select="[modal-header]" />
            <ng-container [ngTemplateOutlet]="isHeaderSettingsTemplateRef() ? headerRefTemplate : headerInnerTemplate" />
          </h5>
        </div>
        @if (showExpandedCross || showCloseCross) {
          <div class="col-auto">
            <div class="form-row">
              @if (showExpandedCross) {
                <div class="col-auto">
                  <mbs-button
                    [icon]="isExpanded ? 'fa fa-compress' : 'fa fa-expand'"
                    [isCtrl]="true"
                    [type]="'dark'"
                    (click)="toggleExpand()" />
                </div>
              }

              @if (showCloseCross) {
                <div class="col-auto">
                  <mbs-button
                    aria-label="Close"
                    data-dismiss="modal"
                    [icon]="'ico ico-Close'"
                    [isCtrl]="true"
                    [type]="'dark'"
                    (click)="close()" />
                </div>
              }
            </div>
          </div>
        }
      </div>
    </header>
  }
  <div [class]="computedBodyClass">
    {{ message }}
    <ng-container
      [ngTemplateOutlet]="isCustomModal ? contentBody : body?.length ? innerTemplate : refTemplate"
      [ngTemplateOutletContext]="{ $implicit: context }" />
  </div>

  @if (showFooter) {
    <div class="modal-footer">
      @if (customFooter) {
        <ng-content select="[modalFooter]" />
      } @else {
        @if (showOkButton) {
          <mbs-button
            [attr.data-e2e]="okButtonLocator"
            [disabled]="okButtonDisabled$ | async"
            [loading]="okButtonLoading$ | async"
            [type]="okButtonType"
            (click)="save()">
            {{ okButtonText }}
          </mbs-button>
        }

        @if (showCancelButton) {
          <mbs-button
            data-dismiss="modal"
            [type]="'secondary'"
            (click)="cancel()">
            {{ cancelButtonText }}
          </mbs-button>
        }
      }
    </div>
  }
}

<ng-template #headerInnerTemplate>
  @if (isHeaderSettingsString()) {
    <span [innerHTML]="header"></span>
  }
</ng-template>

<ng-template #headerRefTemplate>
  <ng-container
    [ngTemplateOutlet]="header"
    [ngTemplateOutletContext]="{ $implicit: context }" />
</ng-template>

<ng-template #innerTemplate>
  <div [innerHTML]="body"></div>
</ng-template>

<ng-template #refTemplate>
  <ng-container
    [ngTemplateOutlet]="body"
    [ngTemplateOutletContext]="{ $implicit: context }" />
</ng-template>

<ng-template #contentBody>
  <ng-content select="[modal-body]" />
</ng-template>
